export const UPDATE_RESUME = "UPDATE_RESUME";
export const UPDATE_RESUME_SUCCESS = "UPDATE_RESUME_SUCCESS";
export const UPDATE_RESUME_ERROR = "UPDATE_RESUME_ERROR";

export const UPDATE_PUBLISHED_RESUME = "UPDATE_PUBLISHED_RESUME";
export const UPDATE_PUBLISHED_RESUME_SUCCESS = "UPDATE_PUBLISHED_RESUME_SUCCESS";
export const UPDATE_PUBLISHED_RESUME_ERROR = "UPDATE_PUBLISHED_RESUME_ERROR";
